(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-layout-columns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('[data-flexi-column-grid]');

    const getBreakpoint = () => {
      const w = window.innerWidth;
      if (w <= 500) return 'mobile';
      if (w <= 900) return 'tablet';
      return 'desktop';
    };

    const revealPagination = (sliderEl) => {
      const el = sliderEl?.querySelector('.blaze-pagination');
      if (!el) return;
      el.classList.remove('u-opacity-0');
      el.classList.add('u-opacity-100');
    };

    const syncCardHeights = (root) => {
      root.style.removeProperty('--flexi-columns-card-min-height');
      const cards = root.querySelectorAll('.flexi-group-wrapper');
      if (!cards.length) return;
      const max = Math.max(...[...cards].map((c) => c.offsetHeight));
      if (max > 0) root.style.setProperty('--flexi-columns-card-min-height', max + 'px');
    };

    const getConfig = (sliderEl) => {
      const desktopSlides = parseFloat(sliderEl.dataset.blazeDesktop) || 4;
      const tabletSlides = parseFloat(sliderEl.dataset.blazeTablet) || 2.2;
      const mobileSlides = parseFloat(sliderEl.dataset.blazeMobile) || 1.2;
      const loop = sliderEl.dataset.blazeLoop === 'true';
      const draggable = sliderEl.dataset.blazeDraggable === 'true';
      const autoplay = sliderEl.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(sliderEl.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = sliderEl.dataset.blazeAutoplayPause === 'true';
      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';

      return {
        all: {
          slidesToShow: desktopSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop,
          draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          enablePagination: paginationStyle === 'dots',
        },
        '(max-width: 900px)': {
          slidesToShow: tabletSlides,
        },
        '(max-width: 500px)': {
          slidesToShow: mobileSlides,
        },
      };
    };

    const destroySlider = (sliderEl) => {
      if (!sliderEl) return;

      sliderEl._flexiScrollbarCleanup?.();
      delete sliderEl._flexiScrollbarCleanup;
      const obs = sliderEl._flexiScrollbarObserver;
      if (obs) {
        obs.disconnect();
        delete sliderEl._flexiScrollbarObserver;
      }

      const instance = sliderEl._flexiBlaze;
      if (instance?.destroy) instance.destroy();
      delete sliderEl._flexiBlaze;

      const paginationEl = sliderEl.querySelector('.blaze-pagination');
      if (paginationEl) paginationEl.innerHTML = '';
    };

    const setupScrollbarPagination = (sliderEl, slider) => {
      const paginationEl = sliderEl.querySelector('.blaze-pagination--scrollbar');
      if (!paginationEl || !slider) return;

      const trackEl = paginationEl.querySelector('.blaze-scrollbar-track');
      const fillEl = paginationEl.querySelector('.blaze-scrollbar-fill');
      const blazeTrack = sliderEl.querySelector('.blaze-track');
      if (!trackEl || !fillEl || !blazeTrack) return;

      let hideTimer = null;
      const showScrollbar = () => {
        paginationEl.classList.add('blaze-scrollbar-visible');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          paginationEl.classList.remove('blaze-scrollbar-visible');
          hideTimer = null;
        }, 1000);
      };

      const updateScrollbar = (percent) => {
        fillEl.style.width = Math.max(0, Math.min(100, percent)) + '%';
      };

      const updateFromState = () => {
        const numStates = slider.states?.length || 1;
        paginationEl.style.display = numStates <= 1 ? 'none' : '';
        if (numStates <= 1) return;
        const idx = slider.stateIndex ?? 0;
        updateScrollbar((idx / (numStates - 1)) * 100);
      };

      slider.onSlide(updateFromState);
      updateFromState();

      const container = sliderEl.querySelector('.blaze-container');
      if (container) {
        container.addEventListener('pointerdown', showScrollbar);
        container.addEventListener('touchstart', showScrollbar);
      }

      trackEl.addEventListener('click', (e) => {
        const rect = trackEl.getBoundingClientRect();
        const percent = ((e.clientX - rect.left) / rect.width) * 100;
        const numStates = slider.states?.length || 1;
        if (numStates <= 1) return;
        const targetIdx = Math.round((percent / 100) * (numStates - 1));
        const steps = targetIdx - (slider.stateIndex ?? 0);
        if (steps > 0) slider.next(steps);
        else if (steps < 0) slider.prev(-steps);
      });

      const obs = new MutationObserver(() => {
        showScrollbar();
        requestAnimationFrame(() => {
          const wrapper = blazeTrack.closest('.blaze-track-wrapper') || blazeTrack.parentElement;
          if (!wrapper) return;
          const wr = wrapper.getBoundingClientRect();
          const tr = blazeTrack.getBoundingClientRect();
          const maxScroll = Math.max(0, tr.width - wr.width);
          if (maxScroll <= 0) return;
          updateScrollbar((Math.max(0, Math.min(1, (wr.left - tr.left) / maxScroll))) * 100);
        });
      });
      obs.observe(blazeTrack, { attributes: true, attributeFilter: ['style'] });
      sliderEl._flexiScrollbarObserver = obs;
      sliderEl._flexiScrollbarCleanup = () => {
        if (hideTimer) clearTimeout(hideTimer);
        container?.removeEventListener('pointerdown', showScrollbar);
        container?.removeEventListener('touchstart', showScrollbar);
      };
    };

    const createSlider = (sliderEl) => {
      if (!sliderEl || sliderEl._flexiBlaze) return sliderEl._flexiBlaze || null;

      const slider = new BlazeSlider(sliderEl, getConfig(sliderEl));
      sliderEl._flexiBlaze = slider;
      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slider.refresh();
          revealPagination(sliderEl);
          if (paginationStyle === 'scrollbar') {
            setupScrollbarPagination(sliderEl, slider);
          }
          const root = sliderEl.closest('[data-flexi-column-grid]');
          if (root) syncCardHeights(root);
        });
      });

      return slider;
    };

    const reinitRootSlider = (root) => {
      const sliderEl = root.querySelector('.blaze-slider');
      if (sliderEl) {
        destroySlider(sliderEl);
        if (getBreakpoint() !== 'desktop') {
          createSlider(sliderEl);
        } else {
          requestAnimationFrame(() => syncCardHeights(root));
        }
      } else {
        requestAnimationFrame(() => syncCardHeights(root));
      }
    };

    roots.forEach((root) => {
      let currentBp = getBreakpoint();

      let _syncTimer = null;
      new ResizeObserver(() => {
        clearTimeout(_syncTimer);
        _syncTimer = setTimeout(() => syncCardHeights(root), 200);
      }).observe(root);

      window.addEventListener('load', () => {
        reinitRootSlider(root);
      });

      window.addEventListener('resize', () => {
        clearTimeout(root._flexiResizeTimer);
        root._flexiResizeTimer = setTimeout(() => {
          const newBp = getBreakpoint();
          if (newBp !== currentBp) {
            currentBp = newBp;
            reinitRootSlider(root);
          } else if (newBp !== 'desktop') {
            const sliderEl = root.querySelector('.blaze-slider');
            const blaze = sliderEl?._flexiBlaze ?? sliderEl?.blazeSlider;
            blaze?.refresh();
            requestAnimationFrame(() => syncCardHeights(root));
          } else {
            requestAnimationFrame(() => syncCardHeights(root));
          }
        }, 150);
      });
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-flexi-column-grid]').forEach((root) => {
        reinitRootSlider(root);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
